/**
 * Multicolumn Toggle - Gère l'affichage "Afficher plus" pour les chips sur mobile
 */
(function () {
  "use strict";

  function initMulticolumnToggle() {
    // Sélectionner toutes les sections multicolumn avec chip-style
    const chipSections = document.querySelectorAll(".multicolumn--chip-style");

    if (chipSections.length === 0) {
      return;
    }

    chipSections.forEach(function (section) {
      const descHtml = section.querySelector(".multicolumn__desc-html");

      // Ne rien faire si pas de contenu
      if (!descHtml) {
        return;
      }

      // Vérifier si on est sur mobile (< 768px)
      function isMobile() {
        return window.innerWidth < 768;
      }

      // Vérifier si le contenu dépasse la hauteur max
      function needsToggle() {
        if (!isMobile()) return false;

        const maxHeight = window.innerWidth < 480 ? 160 : 200;
        const currentHeight = descHtml.scrollHeight;

        return currentHeight > maxHeight + 20; // Marge de 20px
      }

      // Vérifier si le bouton existe déjà
      let toggleBtn = section.querySelector(".multicolumn__toggle-btn");

      // Créer le bouton s'il n'existe pas
      if (!toggleBtn) {
        toggleBtn = document.createElement("button");
        toggleBtn.className = "multicolumn__toggle-btn";
        toggleBtn.textContent = "Afficher plus de marques";
        toggleBtn.setAttribute("aria-expanded", "false");
        toggleBtn.setAttribute("type", "button");

        // Insérer le bouton juste après descHtml
        descHtml.insertAdjacentElement("afterend", toggleBtn);

        // Gérer le clic
        toggleBtn.addEventListener("click", function (e) {
          e.preventDefault();
          const isExpanded = descHtml.classList.contains("is-expanded");

          if (isExpanded) {
            descHtml.classList.remove("is-expanded");
            toggleBtn.textContent = "Afficher plus de marques";
            toggleBtn.setAttribute("aria-expanded", "false");

            // Scroll vers le haut du contenu
            descHtml.scrollIntoView({ behavior: "smooth", block: "nearest" });
          } else {
            descHtml.classList.add("is-expanded");
            toggleBtn.textContent = "Afficher moins de marques";
            toggleBtn.setAttribute("aria-expanded", "true");
          }
        });
      }

      // Fonction pour mettre à jour la visibilité du bouton
      function updateButtonVisibility() {
        if (!toggleBtn) return;

        if (isMobile() && needsToggle()) {
          // Afficher le bouton sur mobile si nécessaire
          toggleBtn.style.display = "block";
        } else {
          // Cacher le bouton sur desktop ou si pas besoin
          toggleBtn.style.display = "none";
          // Réinitialiser l'état expanded
          descHtml.classList.remove("is-expanded");
          if (toggleBtn.getAttribute("aria-expanded") === "true") {
            toggleBtn.textContent = "Afficher plus de marques";
            toggleBtn.setAttribute("aria-expanded", "false");
          }
        }
      }

      // Initialiser l'état au chargement (avec délai pour que le CSS soit appliqué)
      setTimeout(updateButtonVisibility, 200);

      // Écouter les changements de taille d'écran
      let resizeTimer;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateButtonVisibility, 250);
      });
    });
  }

  // Initialiser au chargement du DOM
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMulticolumnToggle);
  } else {
    // DOM déjà chargé
    initMulticolumnToggle();
  }

  // Réinitialiser après les modifications Shopify (éditeur de thème)
  if (typeof window.Shopify !== "undefined" && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", initMulticolumnToggle);
    document.addEventListener("shopify:section:reorder", initMulticolumnToggle);
  }
})();
